import { http } from '@/core/api/';
import academicyear from '@/services/academicyear';

const BaseUrl = 'api/account';

export const getUserMenu = async () => {
  try {
    const { data } = await http.get(`${BaseUrl}/sitemap/`);
    return data;
  } catch (e) {
    return [];
  }
};

export const getAdditionalProfileInfo = async () => {
  try {
    const { data } = await http.get(`${BaseUrl}/getprofileinformation/`);
    if (data) {
      const {
        companies,
        permissions,
        user,
        healthRegions,
        serviceCenters,
      } = data;
      return {
        companies: (companies || []).map(
          ({ id, name, socialSecurityNo, isMainCompany }) => ({
            id,
            name,
            ssn: socialSecurityNo,
            main: isMainCompany,
          })
        ),
        permissions,
        userProfile: user,
        healthRegions,
        serviceCenters,
      };
    }

    return null;
  } catch {
    return null;
  }
};
export const clearCache = () => {
  return http.get(`${BaseUrl}/cleancache/`);
};

export const changeUserPassword = (args) => {
  return http.post(`${BaseUrl}/changepassword/`, args);
};

export const completeUserAgreement = (userId) =>
  http.post(`${BaseUrl}/useragreement`, { userId });

export const updateMyProfile = (params) =>
  http.put(`api/userprofiles/myprofile`, params);

export const searchUserEmail = (params) =>
  http.get(`api/userprofiles/searchuseremail`, { params });

export const trackingNavMenu = (payload) =>
  http.post('api/userprofiles/trackingnavmenu', payload);

export const updateGoalsObjectivesFlag = (value) =>
  http.put(`api/userprofiles/goalsobjectivesflag/${value}`);

export const updateGoalsV2Flag = (peiId, value) =>
  http.put(`api/pei/goalsv2flag/${peiId}/${value}`);

export const getRolesByApp = (appId) =>
  http.get(`api/userprofiles/roles/${appId}`);
